import React from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
  
  const getIcon = (spot) => {
    
    // デフォルトは石碑
    let icon = menu2icon["vis_66_info"];
    
    const tag = spot["タグ"];
    
    if (tag) {
      if (tag.includes("石碑")) {
        icon = menu2icon["vis_66"];
      } else if (tag.includes("記録集")) {
        icon = menu2icon["vis_66_record"];
      }
    }
    
    
    return new L.Icon({
      iconUrl: icon,
      iconRetinaUrl: icon,
      iconSize: [35, 35],
      iconAnchor: [17, 23],
      popupAnchor: [0, -50]
    })
    
  };
  
  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []

    ret.push(<dl className='dl-list is-modal-spot'><dt>地域情報ID</dt><dd>{spot["地域情報ID"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>タイトル</dt><dd>{spot["タイトル"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>所在地市区町</dt><dd>{spot["所在地市区町"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>URL</dt><dd><a target={"_blank"} href={spot["InfoURL"]}>{spot["InfoURL"]}</a></dd></dl>)

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={getIcon(spot)}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
